module.exports = __webpack_public_path__ + "static/media/domainCenterImg2.1dfa1e88.png";